// @flow
export const GROUP_SIZE = 7;



// WEBPACK FOOTER //
// ./src/core/constants/dashboard/index.js